import { instance } from './index';
import { useQuery, useMutation, useQueryClient } from 'react-query';

const contextPath = '/admin/user';
export const useSetUser = () => {
    const queryClient = useQueryClient();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'POST':
                    return postUser(sendParam);
                case 'PUT':
                    return putUser(sendParam);
                case 'PWD_INIT':
                    return pwdInitUser(sendParam);
                case 'DELETE':
                    return deleteUser(sendParam);
                default :
                    return putUser(sendParam);
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries('USER_LIST', { refetchInactive: true })
            },
        }
    )
}

const postUser = async (param) => {
    const sendParam = {
        user_no: param.user_no,
        user_nm: param.user_nm,
        user_tp: param.user_tp,
        detp_cd: param.detp_cd,
    }

    const retVal = await instance.post(contextPath+'/', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const putUser = async (param) => {

    const sendParam = {
        uid: param.uid,
        user_no: param.user_no,
        user_nm: param.user_nm,
        pwd: param.pwd,
        user_tp: param.user_tp,
        detp_cd: param.detp_cd,
    }

    const retVal = await instance.put(contextPath+'/', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const pwdInitUser = async (param) => {

    const sendParam = {
        uid: param.uid,
        user_no: param.user_no,
        user_nm: param.user_nm,
        pwd: param.pwd,
        user_tp: param.user_tp,
        detp_cd: param.detp_cd,
    }

    const retVal = await instance.put(contextPath+'/pwdInit', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const deleteUser = async (param) => {

    const sendParam = {
        uid: param.uid,
    }

    const retVal = await instance.put(contextPath+'/del', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}